import { deletePros } from "api";
import { Error } from "utils/Response";
import { GetPros } from "../GetPros/action";
import { ActionTypes } from "./types";
import { GetDecisionDetails } from "../GetDecisionDetails/action";

export const DeletePros = (Data, id, decisionId) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await deletePros(Data);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 204) {
      dispatch(GetPros(id));
      dispatch(GetDecisionDetails(decisionId, false));
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
